<template>
  <div id="app">
      <div class="container">
          <div class="content">
              <img src="../images/login/welcome.png" />
              <div class="title">欢迎登录智慧人力零工系统</div>

              <div class="input-panel">
                <img src="../images/login/user.png" /> <el-input placeholder="请输入用户账号"  v-model="count"> </el-input>
              </div>
              <div class="input-panel">
                <img src="../images/login/password.png" /> <el-input placeholder="请输入密码"  v-model="password" type="password" @keyup.enter.native='getlogin'> </el-input>
              </div>



              <el-button class="login-btn" type="primary" @click='getlogin()'>登录</el-button>
              <div class="tips">推荐使用谷歌浏览器，<a href="https://www.google.cn/chrome/">点击下载</a></div>
          </div>

      </div>

      <div style="position: fixed;bottom: 15px;left: 100px;font-size: 12px;"><a href="https://beian.miit.gov.cn" target="_blank" style="color: #fff;text-decoration:none;">© qyzhrccs.com 版权所有 粤ICP备2024337838号-1</a> </div>


  </div>
</template>

<script>
  import Message from '@/utils/message.js';
  import commonMethod from '@/utils/util.js';
  export default{
    data:function(){
      return {
          count:'',
          password:'',
          useTime:{
            comeTime:"",
            leaveTime:"",
            submitTime:""
          },


      }
    },
    activated() {
      //console.log("activated公共方法commonMethod",commonMethod)
    },
    created() {
      //console.log("created公共方法commonMethod",commonMethod)
      //进入时间
      this.useTime.comeTime = commonMethod.Utils.currentTime()
      //console.log("当前时间", commonMethod.Utils.currentTime())

    },
    methods: {
      getlogin(){
        let that = this;
          let phone = this.count
          let pwd = this.password
          if(phone == '' || phone == null){Message.error('请输入账号')}
          else if(pwd == '' || pwd == null){ Message.error('请输入密码')}
          else{
            this.post('v2/login/user',{username:phone,password:pwd},false).then(res=>{
              if(res.status == 201){
                //console.log(res);
                  this.$store.commit('settoken',res.data.access_token)
                  this.$store.commit('setmenulist',res.data.menulist)
                  this.$store.commit('setauthlist',res.data.authlist)
                  this.$store.commit('settoken_type',res.data.token_type);
                  this.$store.commit('newAdminid',res.data.adminid);
                  this.$store.commit('setusername',res.data.username);
                  this.$store.commit('newRoleid',res.data.role_id);
                  this.$store.commit('newRolename',res.data.role_name);
                  this.$store.commit('newMobilepwd',res.data.mobilepwd);
                  this.$store.commit('setEnterpriseName',res.data.enterprise_name);

                  this.$store.commit('setUtypeid',res.data.utypeid);
                  this.$store.commit('setMiniUsername',res.data.oausername);
                  this.$store.commit('setAvatars',res.data.avatars);
                  this.$store.commit('setLastLoginTime',res.data.last_login_time);
                  localStorage.setItem('account',res.data.mobileaccount)
                  localStorage.setItem('password',res.data.mobilepwd)


                  this.useTime.leaveTime = commonMethod.Utils.currentTime();
                  this.useTime.submitTime = commonMethod.Utils.currentTime();
                  //that.visitPage()

                  this.$router.push({path:'/'})


              }else{
                Message.error('登录失败')
              }
            })
          }
         },
         visitPage() {
           let params = {
           				name:'后台登录',//临时参数
           				type:3,
           				comeTime: this.useTime.comeTime,
           			  leaveTime: this.useTime.leaveTime,
           			  submitTime: this.useTime.submitTime,
           			}
           this.post('operate/logAdd',params).then(res=>{
           })

         },


      },

    }
</script>

<style scoped>
  .container{background: url(../images/login/bg.png) no-repeat  center;height: 100vh;display: flex;justify-content: center;align-items: center;}
  .content{
    width: 440px;
    height: 450px;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 56px 40px;
    box-sizing: border-box;
  }
  .content .title{
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #666666;
    margin:25px 0 40px;
  }
  .content .input-panel{
    width: 360px;
    height: 50px;
    background: #FFFFFF;
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 10px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    padding:0 17px;
  }
  .content .input-panel img{
    width: 18px;
    height: 20px;
    margin-right:17px;
  }
  .content .input-panel .el-input>>>.el-input__inner{
    border: none;
    margin-right: 10px;
    box-shadow: inset 0 0 0 1000px #FFFFFF!important;/* 修改input自动填充后的默认样式 */
  }

 .content .login-btn.el-button{
    margin-top: 10px;
    width: 360px;
    height: 50px;
    background: #F7A30D;
    border-radius: 10px;
    border: 1px solid #F7A30D;
    margin-bottom: 10px;
  }
   .content .login-btn.el-button--primary:hover{
     background-color: #6F7BE8 !important;
     border: 1px solid #6F7BE8 !important;
   }

  a{text-decoration: none;color: #1e8fff;}
  .tips{width: 100%;text-align: center;}
</style>



// WEBPACK FOOTER //
// src/view/login.vue